var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4781 7.22516L13.6849 6.59511L10.9864 0.329065C10.7975 -0.109688 10.1754 -0.109688 9.9865 0.329065L7.28808 6.59515L0.494842 7.22516C0.0191821 7.26927 -0.173056 7.8609 0.185819 8.17615L5.31133 12.6789L3.81136 19.3343C3.70633 19.8003 4.2096 20.166 4.62033 19.9221L10.4865 16.4388L16.3527 19.9221C16.7634 20.166 17.2667 19.8003 17.1617 19.3343L15.6617 12.6789L20.7872 8.17615C21.146 7.8609 20.9538 7.26927 20.4781 7.22516Z",
    fill: "#FFDC64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9865 0.329065C10.7975 -0.109688 10.1754 -0.109688 9.98652 0.329065L7.28809 6.59516L0.494843 7.22517C0.0191822 7.26929 -0.173057 7.86091 0.185819 8.17616L5.31134 12.6789L3.81136 19.3344C3.70633 19.8004 4.2096 20.166 4.62034 19.9221L5.92964 19.1447C6.11086 11.6853 9.57673 6.43233 12.3208 3.42734L10.9865 0.329065Z",
    fill: "#FFC850"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e2ae3b8b3ad129657d556d70ae0f8c27.svg";
export { ForwardRef as ReactComponent };